<template>
  <a-modal v-model="visible" title="Edit User" :destroyOnClose="true">
    <a-form-model ref="editUserForm" :model="user" :rules="rules" layout="vertical">
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Username" prop="username">
            <a-input placeholder="Username" v-model="user.username" readOnly />
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Email" prop="email">
            <a-input placeholder="Email" v-model="user.email" />
          </a-form-model-item>
        </a-col>
      </a-row>
      <a-row :gutter="16">
        <a-col :span="12">
          <a-form-model-item label="Business" prop="business">
            <a-select v-model="user.businessId" style="width: 100%">
              <a-select-option v-for="business in businesses" :key="business.id" :value="business.id">
                {{ business.name }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </a-col>
        <a-col :span="12">
          <a-form-model-item label="Is Active" prop="isActive">
            <a-switch v-model="user.isActive" />
          </a-form-model-item>
        </a-col>
      </a-row>
    </a-form-model>
    <template #footer>
      <a-button type="primary" @click="save" :loading="isSaving">Save</a-button>
      <a-button @click="cancel">Cancel</a-button>
    </template>
  </a-modal>
</template>
<script>
import { usersMutations } from '../../Store/store';
import { helper } from '../../Utilities/helper';

export default {
  props: {
    value: Boolean,
    user: {
      type: Object,
      defualt: () => ({}),
    },
    businesses: Array,
  },
  data() {
    return {
      rules: {
        username: [{ required: true, message: 'Please input Username', trigger: 'blur' }],
        email: [
          { required: true, message: 'Please input an email', trigger: 'blur' },
          { validator: this.userEmailValidator, trigger: 'blur' },
        ],
        businessId: [{ required: true, message: 'Please pick a Business', trigger: 'change' }],
      },
      isSaving: false,
    };
  },
  computed: {
    visible: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    cancel() {
      this.visible = false;
    },
  async userEmailValidator(rule, value, callback) {
        if (!helper.validateEmail(value)) {
            callback('Please input valid email address!');
        } else if (!(await helper.userCanRegisterEmail(value,this.user.id))) {
            callback('Email already registered!');
        } else {
            callback();
        }
    },
    save() {
      this.$refs.editUserForm.validate(async (valid) => {
        if (valid) {
          this.isSaving = true;
          try {
            await usersMutations.updateUser({
              id: this.user.id,
              email: this.user.email,
              businessId: this.user.businessId,
              isActive: this.user.isActive,
            });

            this.visible = false;
          } catch (error) {
            this.$message.error(error.response?.data?.errors[0]?.message ?? error.message);
          } finally {
            this.isSaving = false;
          }
        }
      });
    },
  },
};
</script>